import React from 'react';
import { useSiteInfo } from '@silvertours/front-entities';
import { Scene, SceneProps } from './common';
import { CalendarScene } from './CalendarScene';
import { SelectStationScene } from './SelectStationScene';
import { SummaryScene } from './SummaryScene';

type Props = {
  scenes: Scene[];
  onClose: () => void;
  onConfirm: () => void;
};

const SearchWizard = ({ onClose, onConfirm, scenes }: Props) => {
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const currentScene = scenes[currentIndex];
  return currentScene.node({
    onClose: () => {
      if (currentScene.goBackOnClose && currentIndex > 0) {
        setCurrentIndex(currentIndex - 1);
      } else {
        onClose();
      }
    },
    onConfirm: () => {
      if (currentIndex === scenes.length - 1) {
        onConfirm();
      } else {
        setCurrentIndex(currentIndex + 1);
      }
    },
  });
};

const useSearchWizard = (): {
  scenes: Scene[];
} => {
  const {
    settings: { featureToggles },
  } = useSiteInfo();

  if (featureToggles.useNewDesignSearchFormV2) {
    return {
      scenes: [
        // ! TODO: Add scenes for variant B
        {
          node: (props: SceneProps) => <SummaryScene {...props} />,
        },
      ],
    };
  }

  return {
    scenes: [
      {
        node: (props: SceneProps) => (
          <SelectStationScene {...props} direction="departure" />
        ),
      },
      {
        node: (props: SceneProps) => <SummaryScene onlyLocations {...props} />,
      },
      {
        node: (props: SceneProps) => <CalendarScene {...props} />,
      },
      {
        node: (props: SceneProps) => <SummaryScene {...props} />,
      },
    ],
  };
};

export { SearchWizard, useSearchWizard };
